import Footer from "components/navigation/footer";
import Header from "components/navigation/header";
import Preloader from "components/preloader";
import InitialState from "components/toolkit/initial-state.component";
import { Outlet, useNavigation } from "react-router-dom";
function Root() {
  const navigation = useNavigation();
  if (navigation.state === "loading") {
    return <Preloader />;
  }
  return (
    <>
      <InitialState />
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}

export default Root;
